<template>
  <IQOS
    :systemDependency="'delivery'"
    :enabled="is_active"
    :title="$t('address_details.title')"
  >
    <div class="mt-16 gap-row-sm" v-if="is_active">
      <div
        v-for="detail in available_details"
        :key="detail"
      >
        <BaseCheckbox
          :value="isDetailActive(detail)"
          @input="toggleDetail(detail)"
          checkedTextColor="v1-grey-3"
          >{{ $t(`address_details.types.${detail}`) }}</BaseCheckbox
        >
      </div>
    </div>

    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("address_details.description") }}
    </p>
    <p class="iqos-comment qrw-paragraph-md mt-16">{{ $t("address_details.required") }}</p>


    <template #actions>
      <IQOSToggle v-model="is_active" />
    </template>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      address_details: [],
      available_details: ["entrance", "floor", "flat"],
      editing: false,
      is_active: false,
    };
  },
  watch: {
    is_active() {
      if (!this.is_active) {
        this.address_details = [];
        this.onEditFinish();
      }
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.$store.commit("setDeliveryAddressDetails", this.address_details);
      this.$store.dispatch("saveCafe");
      // this.editing = false;
    },
    isDetailActive(detail) {
      return this.address_details.includes(detail);
    },
    toggleDetail(detail) {
      const index = this.address_details.indexOf(detail);

      if (index === -1) {
        this.address_details.push(detail);
      } else {
        this.address_details.splice(index, 1);
      }

      this.onEditFinish();
    },
    reset() {
      if (this.cafe.delivery.address_details) {
        this.address_details = this.cafe.delivery.address_details.slice();
      }

      this.is_active = !!this.address_details.length;
    },
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style scoped>
.detail-block:first-of-type {
  margin-top: 0 !important;
}
</style>